import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);    
    }
    const excludedPaths = ['signin-callback', '/login', '/logout', '/register', '/sso'];
    const currentPath = location.pathname;
    
    if (!excludedPaths.some(path => currentPath.includes(path))) {
      console.log('location', currentPath);
      localStorage.setItem('savedRoute', currentPath);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ScrollToTop.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  location: PropTypes.shape().isRequired,
};

export default withRouter(ScrollToTop);
